export const TEAM_WELCOME_ROUTE = '/auth/team-welcome';

const TEAM_ID_PARAM = 'team_id';
const SIGNED_UP_PARAM = 'signup';

/** The welcome page for a team the person just joined. */
export function buildTeamWelcomeHref({
  teamId,
  isNewUser,
}: {
  teamId: string;
  isNewUser: boolean;
}): string {
  const params = new URLSearchParams({ [TEAM_ID_PARAM]: teamId });
  if (isNewUser) params.set(SIGNED_UP_PARAM, '1');
  return `${TEAM_WELCOME_ROUTE}?${params.toString()}`;
}

type RouterQueryValue = string | string[] | undefined;

export function readTeamWelcomeQuery(query: Record<string, RouterQueryValue>): {
  teamId: string | null;
  isNewUser: boolean;
} {
  const first = (value: RouterQueryValue) => (Array.isArray(value) ? value[0] : value);
  const teamId = first(query[TEAM_ID_PARAM])?.trim();
  return {
    teamId: teamId ? teamId : null,
    isNewUser: first(query[SIGNED_UP_PARAM]) === '1',
  };
}
